import { env } from '@packages/runtime-config';
import axios from 'axios';
import { ECookies } from '../cookies';
import { setCookieSafely } from '../cookies/helpers';
import Cookies from 'js-cookie';

type TokensData = {
  refreshToken: string;
  accessToken: string;
  tokenType: string;
  expiresIn: string;
};

let memoizedPromise: Promise<void> | null = null;

const refreshTokenFn = async (): Promise<void> => {
  const oldAccessToken = Cookies.get(ECookies.TOKEN);
  const oldRefreshToken = Cookies.get(ECookies.REFRESH_TOKEN);

  try {
    const host = env.API_URL || '/api';

    const response = await axios.post(`${host}/authentication/token/refresh `, {
      refreshToken: oldRefreshToken,
      accessToken: oldAccessToken,
    });

    if (response.data.data.accessToken) {
      const { accessToken, expiresIn, refreshToken, tokenType }: TokensData =
        response.data.data;

      setCookieSafely(ECookies.TOKEN, accessToken);
      setCookieSafely(ECookies.REFRESH_TOKEN, refreshToken);
      setCookieSafely(ECookies.TOKEN_EXPIRES_IN, expiresIn);
      setCookieSafely(ECookies.TOKEN_TYPE, tokenType);
    }
  } catch {
    // noop
  }
};

const maxAge = 10000; // 10sec

export const memoizedRefreshToken = () => {
  if (!memoizedPromise) {
    memoizedPromise = refreshTokenFn().then(() => {
      setTimeout(() => {
        if (memoizedPromise) {
          memoizedPromise = null;
        }
      }, maxAge);
    });
  }

  return memoizedPromise;
};
